"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import _ from "lodash";
import AllotmentShop from "@/views/managements/teammanager/components/dialog/details/AllotmentShop.vue";
import MemberLogs from "@/views/managements/teammanager/components/dialog/details/MemberLogs.vue";
import AccessDevices from "@/views/managements/teammanager/components/dialog/details/AccessDevices.vue";
let MemberDetailDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.activeTab = "split_shop";
    this.account_item = null;
  }
  getDepartments(departs) {
    return _.map(departs, "name").join("\u3001");
  }
  open(data) {
    return __async(this, null, function* () {
      try {
        this.account_item = data;
        this._member_dialog.show();
        this.$nextTick(() => __async(this, null, function* () {
          yield this._allotment_shop.start();
        }));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  closeDetail() {
    return __async(this, null, function* () {
      this._member_dialog.hide();
      this.activeTab = "split_shop";
      this.account_item = null;
    });
  }
};
__decorateClass([
  Ref("member-detail-dialog")
], MemberDetailDialog.prototype, "_member_dialog", 2);
__decorateClass([
  Ref("allotment-shop")
], MemberDetailDialog.prototype, "_allotment_shop", 2);
__decorateClass([
  Ref("member-logs")
], MemberDetailDialog.prototype, "_member_logs", 2);
MemberDetailDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      AllotmentShop,
      MemberLogs,
      AccessDevices
    }
  })
], MemberDetailDialog);
export {
  MemberDetailDialog as default
};
